import React from 'react';

// eslint-disable-next-line react/prefer-stateless-function
export class NCEIFooter extends React.Component {
  render() {
    return (
      <div id="nceiFooter">
        <table width="100%" border="0" cellPadding="0" cellSpacing="0" summary="Footer Layout Table">
          <tbody>
            <tr>
              <td className="topnav">
                <div className="topnav">
                  &nbsp;
                  <a href="//www.noaa.gov/" title="National Oceanic &amp; Atmospheric Administration" className="topnav">NOAA</a>
                  {' '}
                  &gt;
                  {' '}
                  <a href="//www.nesdis.noaa.gov/" title="NOAA Satellite &amp; Information Service" className="topnav">NESDIS</a>
                  {' '}
                  &gt;
                  {' '}
                  <a
                    href="/"
                    title="go to the National Centers for Environmental Information (formerly the National Geophysical Data Center)"
                    className="topnav"
                  >
                    NCEI (formerly NGDC)
                  </a>
                  {' '}
                  &gt;
                  {' '}
                  <a href="/hazard/" title="Natural Hazards" className="topnav">Natural Hazards</a>
                </div>
              </td>
              <td style={{ textAlign: 'right' }} className="topnav">
                <div className="topnav">
                  <a href="mailto:haz.info@noaa.gov" className="topnav">Questions: haz.info@noaa.gov</a>
                  &nbsp;
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <hr />
        <div id="nceiFooterLower">
          <a href="//www.ngdc.noaa.gov/ngdc.html" title="go to home">Home</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/ngdcinfo/phone.html" title="go to directory of contacts">Contacts</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/ngdcinfo/onlineaccess.html" title="go to data available">Data</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/ngdcinfo/privacy.html#disclaimer" title="go to privacy, disclaimer, and copyright notices">Disclaimers</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/education/education.html" title="go to education and outreach resources and links">Education</a>
          &nbsp;|&nbsp;
          <a href="//www.ncei.noaa.gov/news" title="go to news and features">News</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/ngdcinfo/privacy.html" title="go to privacy, disclaimer, and copyright notices">Privacy Policy</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/privacy-act-statement-data-requestors.pdf" title="go to privacy act statement">Privacy Act Statement</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/sitemap/sitemap.html" title="go to an index of the Web site">Site Map</a>
          &nbsp;|&nbsp;
          <a href="//www.ngdc.noaa.gov/feedback/" title="provide feedback on the Web site">Take Our Survey</a>
        </div>
      </div>
    );
  }
}
